// @ts-check
import {ComboSegmentSection} from './ComboSegmentSection'
import {ComboSetupSection} from './ComboSetupSection'
import {RouteTypeDropown} from './RouteTypeDropown'

export const ProductComboSetup = () => {
  return (
    <div className="flex flex-col gap-6">
      <ComboSetupSection />

      <div className="flex flex-col gap-6 rounded-lg bg-gray-850 p-6">
        <ComboSegmentSection />
        <div className="h-px bg-gray-600" />
        <RouteTypeDropown />
      </div>
    </div>
  )
}
